let o = {};


const HW = 'arduino';

o.unbanHW = () => {
    const blockMenu = Entry.getMainWS().blockMenu;
    const categoryData = blockMenu._categoryData;
    let threads;

    if (categoryData) {
        threads = categoryData.find((c) => {
            return c.category === HW;
        });
        if (threads)
            threads = threads.blocks;
    } else threads = blockMenu.code.getThreads();

    if (_.isEmpty(threads)) return;

    const getCategory = EntryStatic.getCategoryByBlock;
    const BLOCK = Entry.block;

    const arr = threads.reduce((ret, t) => {
        let type;
        if (t instanceof Entry.Thread) {
            t = t.getFirstBlock();
            type = t.type;
        }
        else type = t;

        if (!type || getCategory(type) !== HW) return ret;

        const { isNotFor, skeleton } = BLOCK[type];

        if (!isNotFor || skeleton === 'basic_button')
            return ret;

        ret = [
            ...ret,
            ...isNotFor
        ];

        return ret;
    }, []);

    blockMenu._bannedClass = _.difference(
        blockMenu._bannedClass, arr
    );
    blockMenu.align();
};

o.appendDefaultHardWareMenu = (blockJSON) => {
    const HW_DEFAULT = [
        'arduino_open_with_brown',
        'arduino_open_with_sally',
        'arduino_reconnect',
        'arduino_open',
        'arduino_connect',
        'arduino_download_connector',
        'line_hardware_noti1',
        'line_hardware_noti2',
        'line_hardware_noti3',
    ];
    const arduino = blockJSON.find((data) => data.category === 'arduino');
    if(arduino) {
        arduino.blocks = _.union(arduino.blocks, HW_DEFAULT);
    }
    return blockJSON;

};

o.generateBlocks = (blockJSON) => {
    return blockJSON.reduce((ret, b) => {
        b.blocks && b.blocks.forEach((innerBlock) => {
            const block = Entry.block[innerBlock];
            if (!block || !block.def) {
                ret.push([{ type: innerBlock }]);
            } else {
                const { defs } = block;
                if (defs)
                    defs.forEach(each => { ret.push([ each ]); });
                else ret.push([ block.def ]);
            }
        });

        return ret;
    }, []);
};

function lockThread(thread) {
    thread.map(function(b) {
        b.emphasized = true;
        if (b.params) {
            for (var i in b.params) {
                var param = b.params[i];
                if (param && param.type) lockThread([param]);
            }
        }
        if (b.statements) {
            for (let key in b.statements) lockThread(b.statements[key]);
        }
    });
}
o.lockThread = lockThread;

export default o;



// WEBPACK FOOTER //
// ./utils/util.js